import qs from 'query-string'
import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

export const getTemplates = async ({
  companyId,
  includePepperTemplate
}: {
  companyId: string
  includePepperTemplate?: number
}): Promise<TemplateListResponse> => {
  try {
    const endpoint = qs.stringifyUrl(
      {
        url: '/templates',
        query: {
          company_id: companyId,
          ...(includePepperTemplate && {
            include_pepper_template: 1
          })
        }
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.get(endpoint)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const getPepperTemplates = async (): Promise<TemplateListResponse> => {
  try {
    const response = await axios.get(`/templates`)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const createTemplates = async ({
  companyId,
  templateName
}: {
  companyId: string
  templateName: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post('/templates', {
      template_name: templateName,
      company_id: companyId
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const publishTemplate = async ({
  templateId
}: {
  templateId: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(`/templates/${templateId}`, {
      is_published: 1
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
